import app from '@/entries/main';
app.mount('#app');
